module.exports = __webpack_public_path__ + "static/img/pitch_white_wide.3186e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_white_wide.png
// module id = mYbJ
// module chunks = 94